import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  children: React.ReactNode;
  variant?: 'ink' | 'gold' | 'premium';
  className?: string;
};
export function CtaButton({
  children,
  variant = 'ink',
  className = ''
}: CtaButtonProps) {
  const styles = variant === 'premium' ? 'bg-premium text-ink border border-premium-deep shadow-[0_6px_18px_-6px_rgba(150,110,40,0.55)] hover:bg-premium-deep' : variant === 'gold' ? 'bg-gold text-white hover:bg-[#a5712f]' : 'bg-ink text-cream hover:bg-ink-soft';
  return <a href="#offer" className={`group inline-flex items-center justify-center gap-3 px-7 py-4 text-sm font-bold uppercase tracking-[0.12em] transition-[background-color,transform] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-cream ${styles} ${className}`} data-id="element-76" data-mp="25j1jle4mq1x0">
      <span data-id="element-77" data-mp="3qu0a4xnxjgdp">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden data-id="element-78" data-mp="2hacbfsek5cku" />
    </a>;
}